import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import './LinkCorporationInvite.css';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { v4 as uuidv4 } from 'uuid';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import ErrorHelper from '@/component/common/ErrorHelper';

export default function LinkCorporationInvite({
    setValue,
    getValues,
    clearErrors,
    errorlist,
    setErrorCreateTicket,
    defaultSubdomainInvited,
    disabled,
    ticketType,
    setIsEdited,
    register
}) {
    const urlGen = defaultSubdomainInvited ? defaultSubdomainInvited : Utils.randomSubDomainCorporation();
    const corporationDetail = useRecoilValue(corporationAtom);
    const [subDomainInvited, setSubDomainInvited] = useState(urlGen);
    let inviterOrganizationDomain = ''
    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) {
        inviterOrganizationDomain = corporationDetail.inviterOrganizationDomain
    } else {
        inviterOrganizationDomain = corporationDetail?.organizationDomain
    }

    useEffect(() => {
        register('subDomainInvited');
        setValue('subDomainInvited', urlGen);
        setSubDomainInvited(urlGen);
    }, []);

    const handleOnchange = e => {
        let value = e.target.value;
        
        if (/^[A-Za-z0-9-]*$/.test(value) === false) {
            return;
        }
        if (Utils.isEmptyString(value.trim())) {
            setErrorCreateTicket(
                'subDomainInvited',
                { type: 'manual', message: I18n.get('COMM01MSG11') },
                { shouldFocus: true }
            );
            setValue('subDomainInvited', value);
            return setSubDomainInvited(value);

        }

        if(value.length > 120) {
            let newValue = value.slice(0, 120);
            setValue('subDomainInvited', newValue);
            clearErrors('subDomainInvited');
            return setSubDomainInvited(newValue);
        }

        setValue('subDomainInvited', value);
        setSubDomainInvited(value);
        clearErrors('subDomainInvited');
        setIsEdited(true)
    };

    return (
        <div className="form-addTicket">
            <div className="form-addTicket-label">
                窓口のURL <span className="required">*</span>
            </div>
            <div className="url-generated-invite">
                <div className="url-part1">
                    <OverFlowTooltipWithTabsMui
                        value={ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT
                            ? `${window.location.origin}/${inviterOrganizationDomain}/c/`
                            : `${window.location.origin}/${inviterOrganizationDomain}/p/`}
                        className="corporation-name-invited"
                    />
                </div>

                <TextField
                    name="subDomainInvited"
                    className="input-corporationAlias"
                    value={subDomainInvited}
                    variant="outlined"
                    onChange={handleOnchange}
                    disabled={disabled ? disabled : false}
                    error={!Utils.isEmptyObject(errorlist.subDomainInvited)}
                />
                
            </div>
            <div>
                    <ErrorHelper
                        isShowError={
                            !Utils.isEmptyObject(errorlist.subDomainInvited)
                        }
                        textError={errorlist['subDomainInvited']?.message}
                        isShowNoticeIcon={false}
                    />
                </div>
        </div>
    );
}
